import { MapStylePresetType } from '@/components/DesignStudio/MapStyleProperties/types';

export const MAP_STYLE_PRESETS: MapStylePresetType[] = [
    {
        id: 'streets-v11',
        label: 'Streets',
        thumbnail: require('@/assets/design-studio/map-styles/thumbnails/streets.png'),
        value: 'streets-v11'
    },
    {
        id: 'satellite-v9',
        label: 'Satellite',
        thumbnail: require('@/assets/design-studio/map-styles/thumbnails/satellite.png'),
        value: 'satellite-v9'
    },
    {
        id: 'light-v10',
        label: 'Light',
        thumbnail: require('@/assets/design-studio/map-styles/thumbnails/light.png'),
        value: 'light-v10'
    },
    {
        id: 'dark-v10',
        label: 'Dark',
        thumbnail: require('@/assets/design-studio/map-styles/thumbnails/dark.png'),
        value: 'dark-v10'
    },
    {
        id: 'martumo/cl3oxhe7r008o15l7fkejdet2',
        label: 'Romantic',
        thumbnail: require('@/assets/design-studio/map-styles/thumbnails/romantic.png'),
        value: 'martumo/cl3oxhe7r008o15l7fkejdet2'
    },
    {
        id: 'martumo/cl3ovcfkc000e14pkj9cg6joc',
        label: 'Vintage',
        thumbnail: require('@/assets/design-studio/map-styles/thumbnails/vintage.png'),
        value: 'martumo/cl3ovcfkc000e14pkj9cg6joc'
    },
    {
        id: 'martumo/cl3ov42hh001j14p43atfipz6',
        label: 'Noir',
        thumbnail: require('@/assets/design-studio/map-styles/thumbnails/noir.png'),
        value: 'martumo/cl3ov42hh001j14p43atfipz6'
    },
    {
        id: 'martumo/cl3ou4lhn002h15qeeemrhc98',
        label: 'Modern',
        thumbnail: require('@/assets/design-studio/map-styles/thumbnails/modern.png'),
        value: 'martumo/cl3ou4lhn002h15qeeemrhc98'
    },
    {
        id: 'martumo/cl3osfplf000c14qksywdcecr',
        label: 'Pop Art',
        thumbnail: require('@/assets/design-studio/map-styles/thumbnails/pop-art.png'),
        value: 'martumo/cl3osfplf000c14qksywdcecr'
    },
    {
        id: 'martumo/cl3osaw99001315qytxna4rs8',
        label: 'Blueprint',
        thumbnail: require('@/assets/design-studio/map-styles/thumbnails/blueprint.png'),
        value: 'martumo/cl3osaw99001315qytxna4rs8'
    },
    {
        id: 'martumo/clm0tfw9a01v701ph0z67afg5',
        label: 'Sand',
        thumbnail: require('@/assets/design-studio/map-styles/thumbnails/sand.png'),
        value: 'martumo/clm0tfw9a01v701ph0z67afg5'
    },
    {
        id: 'martumo/cl3os4jdf000x15o2uh3idliu',
        label: 'Monochrome - Green',
        thumbnail: require('@/assets/design-studio/map-styles/thumbnails/monochrome-green.png'),
        value: 'martumo/cl3os4jdf000x15o2uh3idliu'
    },
    {
        id: 'martumo/cl3orr3hq002k15nt90aat5bi',
        label: 'Monochrome - Red',
        thumbnail: require('@/assets/design-studio/map-styles/thumbnails/monochrome-red.png'),
        value: 'martumo/cl3orr3hq002k15nt90aat5bi'
    },
    {
        id: 'martumo/cl3orhqu7001h14o8r8vceq4h',
        label: 'Monochrome - Blue',
        thumbnail: require('@/assets/design-studio/map-styles/thumbnails/monochrome-blue.png'),
        value: 'martumo/cl3orhqu7001h14o8r8vceq4h'
    },
    {
        id: 'martumo/cl3or5hnk000w14o8g3w0v6g9',
        label: 'Monochrome - Dark Blue',
        thumbnail: require('@/assets/design-studio/map-styles/thumbnails/monochrome-dark-blue.png'),
        value: 'martumo/cl3or5hnk000w14o8g3w0v6g9'
    },
    {
        id: 'martumo/cl3onxf2f001214ple0x3ced8',
        label: 'Monochrome - Light Blue',
        thumbnail: require('@/assets/design-studio/map-styles/thumbnails/monochrome-light-blue.png'),
        value: 'martumo/cl3onxf2f001214ple0x3ced8'
    },
    {
        id: 'martumo/cl3oq78jg000t15o2prbs9wou',
        label: 'Monochrome - White',
        thumbnail: require('@/assets/design-studio/map-styles/thumbnails/monochrome-white.png'),
        value: 'martumo/cl3oq78jg000t15o2prbs9wou'
    },
    {
        id: 'martumo/cl3oqhe0d001314l1utt27q85',
        label: 'Monochrome - Black',
        thumbnail: require('@/assets/design-studio/map-styles/thumbnails/monochrome-black.png'),
        value: 'martumo/cl3oqhe0d001314l1utt27q85'
    },
    {
        id: 'custom-map-style',
        label: 'Custom Style',
        thumbnail: require('@/assets/design-studio/map-styles/thumbnails/custom-map-style.png'),
        value: 'username/style_id'
    }
];
